import { useEffect, useState } from "react";
import HexCard from "../../../../../components/HexCard";

import { getLabel } from "../../../../../hooks/use-labels";
import { formatAddress, getConsumer } from "../../../../../utils/common-utils";

import DeliveryAddressModal from "./DeliveryAddressModal";
import HexIconContent from "../../../../../components/HexIconContent";
import { useDispatch, useSelector } from "react-redux";
import { setDeliveryAddressInformation } from "../../../../../redux/reducers/order/order-action";
import { saveOrderDetails } from "../cart-details-utils";
import ProductUpdatedModal from "../../Components/ProductUpdatedModal";

const DeliveryAddressCard = ({ disabled }) => {
  const { deliveryAddress, deliveryType } = useSelector((state) => state.order);

  const dispatch = useDispatch();

  const [mapModal, setMapModal] = useState(false);

  const [consumerAddress, setConsumerAddress] = useState(deliveryAddress);
  const [error, setError] = useState("");

  const [loading, setLoading] = useState(false);
  const [emptyCartModal, setEmptyCartModal] = useState(false);

  useEffect(() => {
    if (consumerAddress && !disabled) {
      setOrderInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deliveryAddress]);

  useEffect(() => {
    if (!disabled) {
      if (deliveryType && !deliveryAddress) {
        const { address } = getConsumer();
        dispatch(setDeliveryAddressInformation(address));
        setOrderInfo();
      } else if (deliveryType.consumerPickup && error) {
        setError("");
      } else if (!deliveryType.consumerPickup) {
        setOrderInfo();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deliveryType]);

  const setOrderInfo = () => {
    setLoading(true);
    const { address } = getConsumer();

    saveOrderDetails({
      successCB: () => {
        setLoading(false);

        !consumerAddress && setConsumerAddress(address);
        setError("");
      },
      errorCB: ({ message, code }) => {
        if (code === "cart.empty") {
          setEmptyCartModal(true);
        } else if (code.includes("address")) {
          setError(message);
        }

        !consumerAddress && setConsumerAddress(address);
        setLoading(false);
      },
    });
  };

  const toggleModal = () => {
    setMapModal((prev) => !prev);
  };

  const saveAddress = (address) => {
    const { location, ...restAddress } = address;
    const addressInfo = { ...restAddress, ...location };
    dispatch(setDeliveryAddressInformation(addressInfo));
    toggleModal();
  };

  return (
    <HexCard
      className={`delivery-address-card image-content-card mb-20 ${
        error ? "error-bordered-card" : ""
      }`}
    >
      {emptyCartModal && <ProductUpdatedModal />}

      {mapModal && (
        <DeliveryAddressModal
          address={deliveryAddress}
          onClose={toggleModal}
          onSave={saveAddress}
          error={error}
        />
      )}

      <HexIconContent
        className={!disabled && "pointer"}
        onClick={!disabled ? () => toggleModal() : null}
        title={getLabel("deliveryAddressLabel")}
        titleClass={"font-18-regular-500-lh-22"}
        value={deliveryAddress ? formatAddress(deliveryAddress) : ""}
        valueClass="image-content-description"
        icon={"/assets/icons/shopping-cart/delivery-address.svg"}
        loading={loading}
        error={error}
      />
    </HexCard>
  );
};

export default DeliveryAddressCard;
